import React from 'react';
import { ConfigProvider } from 'antd';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import theme from './theme';

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <ConfigProvider theme={theme}>
            <StyledThemeProvider theme={theme}>
                {children}
            </StyledThemeProvider>
        </ConfigProvider>
    );
};

export default ThemeProvider;